import BaseApiService from './BaseApiService'
import type { ApiKey } from '../types'

export interface CreateApiKeyResponse {
  apiKeyId: string
  name: string
  keyPrefix: string
  capabilities: string
  workspaceId: string | null
  folderId: string | null
  fullKey: string
  createdAt: string
}

class ApiKeysApiService extends BaseApiService {
  // No workspaceId here -- a key always belongs to whichever workspace is currently active
  // (sent as the X-Workspace-Id header, see BaseApiService), resolved server-side.
  create(payload: {
    name: string
    folderId?: string
    capabilities?: 'render' | 'render_share'
    /** Test keys only: also upload, download and delete templates through the Docmosis-compatible API. */
    manageTemplates?: boolean
  }): Promise<CreateApiKeyResponse> {
    return this.post<CreateApiKeyResponse>('/v1/api-keys/create', payload)
  }

  list(): Promise<ApiKey[]> {
    return this.post<ApiKey[]>('/v1/api-keys/list')
  }

  revoke(apiKeyId: string): Promise<void> {
    return this.post<void>('/v1/api-keys/revoke', { apiKeyId })
  }
}

export const apiKeysApiService = new ApiKeysApiService()
